<template>
  <div class="app"></div>
</template>

<script>
export default {
  name: "index",
};
</script>

<style lang="scss"></style>
